import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=6deef83c&scoped=true"
import script from "./InvoicesList.vue?vue&type=script&lang=js"
export * from "./InvoicesList.vue?vue&type=script&lang=js"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&id=6deef83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deef83c",
  null
  
)

export default component.exports